export default __webpack_public_path__ + "static/media/next.0f5ab318.svg";